<template>
  <div class="container">
    <Modal
      v-model="importResultModal"
      title="导入结果"
    >
      <div class="import-result-modal">
        <h3>
          成功导入{{
            importResultData ? importResultData.successImportCount : ""
          }}个，错误信息{{
            importResultData ? importResultData.errorData.length : ""
          }}个
        </h3>
        <div v-for="item in importResultList">{{ item }}</div>
      </div>
    </Modal>
    <div class="handle-wrapper">
      <div class="handle-left">
        <Input
          v-model="searchText"
          search
          placeholder="搜索客户..."
          @on-change="searchCustomer"
          clearable
          icon="ios-search"
          style="width: 230px; margin-right: 20px"
        ></Input>
        <DatePicker
          type="month"
          placement="bottom-end"
          placeholder="选择月份"
          style="width: 200px; margin-right: 30px"
          v-model="yearMonth"
          @on-change="changeDate"
        />
        <Select
          placeholder="筛选业务员"
          v-model="salesVisible"
          label-in-value
          multiple
          filterable
          @on-change="choseSalesVisible"
          style="width: 180px; margin-right: 30px"
        >
          <Option
            v-for="item in salesVisibleMember"
            :value="item._id"
            :key="item._id"
          >{{ item.name }}</Option>
        </Select>
        <Select
          placeholder="筛选部门"
          v-model="department"
          label-in-value
          multiple
          filterable
          @on-change="choseDepartment"
          style="width: 180px; margin-right: 30px"
        >
          <Option
            v-for="item in departmentList"
            :value="item._id"
            :key="item._id"
          >{{ item.name }}</Option>
        </Select>
        <Select
          v-model="tableMode"
          @on-change="changeTableMode"
          style="width:100px"
        >
          <Option
            v-for="item in tableModeList"
            :value="item.value"
            :key="item.value"
          >{{ item.label }}</Option>
        </Select>
      </div>
      <div class="handle-right">
        <div class="page-wrap">
          <Select
            v-model="limit"
            size="small"
            style="width: 60px; margin-right: 20px"
            @on-change="changeLimit"
          >
            <Option
              v-for="item in limitList"
              :value="item.value"
              :key="item.value"
            >{{ item.label }}</Option>
          </Select>
          <span>共{{ totalRows }}条</span>
          <Page
            :total="totalRows"
            :page-size="limit"
            @on-change="loadImportFileProcess"
            show-total
            simple
            style="min-width: 160px"
          />
        </div>
        <Button
          @click="$refs.ImportARTableModal.openModal()"
          style="margin-right: 12px"
        >Excel导入账龄表</Button>
      </div>
    </div>
    <div
      class="table-wrapper"
      ref="tableWrapper"
      v-if="tableMode === 'modeA'"
    >
      <Table
        :columns="columns"
        :data="statViewB"
        :height="tableHeight"
        :loading="tableLoading"
        border
      ></Table>
    </div>
    <div
      class="table-wrapper"
      ref="tableWrapper"
      v-else-if="tableMode === 'modeB'"
    >
      <Table
        :columns="columns"
        :data="statViewB"
        :height="tableHeight"
        :loading="tableLoading"
        border
      ></Table>
    </div>
    <ImportARTableModal
      ref="ImportARTableModal"
      @importResult="openImportResultModal"
    />
    <ARDetailDrawer ref="ARDetailDrawer" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { arrayIntersection } from "@/utils";
import ImportARTableModal from "./ImportARTableModal.vue";
import ARDetailDrawer from "./ARDetailDrawer.vue";
import _ from "lodash";
import dayjs from "dayjs";

export default {
  name: "ImportARTable",
  components: {
    ImportARTableModal,
    ARDetailDrawer,
  },
  data() {
    return {
      tableHeight: 300,
      searchText: null,
      limit: 20,
      page: 0,
      salesVisible: "",
      department: "",
      tableLoading: false,
      importResultModal: false,
      importResultData: null,
      importResultList: null,
      filterQuery: {},
      limitList: [
        { value: 20, label: "20" },
        { value: 100, label: "100" },
        { value: 300, label: "300" },
      ],
      tableMode: "modeA",
      tableModeList: [
        {
          value: "modeA",
          label: "模式A",
        },
        {
          value: "modeB",
          label: "模式B",
        },
      ],
      columns: [
        {
          title: "公司",
          key: "company",
          align: "left",
          fixed: "left",
          minWidth: 80,
          render: (h, params) => h('div', params.row.company?.abbr),
        },
        {
          title: "部门",
          key: "department",
          align: "left",
          fixed: "left",
          minWidth: 60,
          render: (h, params) => {
            return h(
              "div",
              params.row.customer.department
                ? params.row.customer.department.name
                : ""
            );
          },
        },
        {
          title: "收款业务",
          key: "paymentSales",
          align: "center",
          fixed: "left",
          minWidth: 80,
          render: (h, params) => {
            return h(
              "div",
              params.row.customer.paymentSales.map((x) => x.name).join(",")
            );
          },
        },
        {
          title: "客户",
          key: "customer",
          fixed: "left",
          minWidth: 190,
          render: (h, params) => {
            return h(
              "span",
              {
                style: { cursor: "pointer", color: "#42b983" },
                on: {
                  click: () => {
                    this.$refs.ARDetailDrawer.openDrawer(
                      params.row,
                      this.yearMonth
                    );
                  },
                },
              },
              this.dataTransform(params.row.customer, "name")
            );
          },
        },
        {
          title: "此后回款",
          key: "receiveAfterSpecDate",
          fixed: "left",
          align: "right",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "div",
              params.row.receiveAfterSpecDate
                ? Number(params.row?.receiveAfterSpecDate).toLocaleString(
                    "zh",
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )
                : "-"
            );
          },
        },
        {
          title: "应收总额",
          key: "totalAccountsReceivable",
          fixed: "left",
          align: "right",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "div",
              params.row.totalAccountsReceivable
                ? Number(params.row?.totalAccountsReceivable).toLocaleString(
                    "zh",
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )
                : "-"
            );
          },
        },
        {
          title: "逾期总额",
          key: "totalPastDueAR",
          align: "right",
          fixed: "left",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "div",
              params.row.totalPastDueAR
                ? Number(params.row?.totalPastDueAR).toLocaleString("zh", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                : "-"
            );
          },
        },
        {
          title: "账龄",
          key: "longestARMonthCount",
          align: "right",
          fixed: "left",
          minWidth: 60,
          render: (h, params) => {
            return h("div", params.row.longestARMonthCount);
          },
        },
      ],
      salesVisibleMember: [],
      departmentList: [],
      yearMonth: null,
      ARTable: [],
    };
  },
  computed: mapState({
    user: (state) => state.auth.currentUser,
    statViewB: (state) => state.salesStat.statViewB,
    totalRows: (state) => state.salesStat.statViewBCounts,
  }),
  methods: {
    ...mapActions({
      getStatViewB: "salesStat/getStatViewBAction",
      getUsersList: "user/getSimpleUserListAction",
      getDepartmentList: "department/getDepartmentListAction",
    }),
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    // 数据处理
    dataTransform(params, item) {
      let value = null;
      if (params && params.abbr) {
        value = params.abbr;
      } else {
        value = _.get(params, item, "-");
      }
      return value;
    },
    async loadImportFileProcess(page) {
      this.columns.splice(7, this.columns.length - 2);
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        tableMode: this.tableMode,
        skip: this.page * this.limit,
      };
      if (this.searchText) {
        this.filterQuery.cus_name = this.searchText;
      } else {
        delete this.filterQuery.cus_name;
      }
      this.$router.push({
        path: `/home/importARTable`,
        query: {
          ...this.filterQuery,
        },
      });
      try {
        this.tableLoading = true;
        const data = await this.getStatViewB(this.filterQuery);
        this.tableLoading = false;
        if (this.tableMode === "modeA") {
          for (let i = 0; i <= 24; i++) {
            let date = {};
            date.key = `date${i}`;
            date.minWidth = 60;
            date.align = "right";
            date.children = [
              {
                title: `${i + 1}个月`,
                key: "age",
                minWidth: 70,
                align: "right",
              },
            ];
            const ARdate = dayjs(this.yearMonth).subtract(i, "month");
            const ARYear = ARdate.year();
            const ARMonth = ARdate.month() + 1;
            date.renderHeader = (h, params) => {
              return h("div", `${ARdate.format("YY")}/${ARMonth}`);
            };
            date.children[0].render = (h, params) => {
              if (params.row.arTable) {
                for (let j = 0; j < params.row?.arTable.length; j++) {
                  if (
                    params.row.arTable[j].year == ARYear &&
                    params.row.arTable[j].month == ARMonth
                  ) {
                    let ar = params.row.arTable[j].accountsReceivable;
                    if (ar) {
                      ar = (ar / 10000).toFixed(2);
                    }
                    return h("div", ar);
                  }
                }
              }
            };
            this.columns.push(date);
          }
        } else {
          // 模式B
          for (let j = 0; j <= 24; j++) {
            let date = {};
            date.key = `date${j}`;
            date.minWidth = 70;
            date.align = "right";
            date.renderHeader = (h, params) => {
              return h("div", ``);
            };
            date.render = (h, params) => {
              if (params.row.arTable && j < params.row.arTable.length) {
                let ar = params.row.arTable[j]?.accountsReceivable;
                if (ar) {
                  ar = (ar / 10000).toFixed(2);
                }
                // 计算逾期月份
                const arTableYearMonth =
                  params.row.arTable[j]?.year +
                  "-" +
                  params.row.arTable[j]?.month;
                const diffYearMonth =
                  dayjs(this.yearMonth).diff(arTableYearMonth, "month") + 1;
                const monthNum = `${diffYearMonth}个月`;
                return h("div", [
                  h(
                    "div",
                    String(params.row.arTable[j]?.year).slice(-2) +
                      "/" +
                      params.row.arTable[j]?.month
                  ),
                  h("div", monthNum),
                  h("div", ar),
                ]);
                // return h("div", monthNum + ar);
              }
            };
            this.columns.push(date);
          }
        }
      } catch (error) {
        this.$Message.error(`加载失败：${error}`);
        this.tableLoading = false;
      }
    },
    searchCustomer: _.debounce(function () {
      this.page = 0;
      this.loadImportFileProcess();
    }, 1000),
    // 切换日期
    changeDate(e) {
      if (e) {
        this.columns.splice(7, this.columns.length - 2);
        this.filterQuery.year = e.split("-")[0];
        this.filterQuery.month = e.split("-")[1];
      } else {
        this.yearMonth = dayjs().subtract(1, "month").format("YYYY-M");
        this.filterQuery.year = dayjs(this.yearMonth).year();
        this.filterQuery.month = dayjs(this.yearMonth).month() + 1;
      }
      this.loadImportFileProcess();
    },
    // 切换limit
    changeLimit() {
      this.page = 0;
      this.loadImportFileProcess();
    },
    // 切换表格显示模式
    changeTableMode() {
      this.columns.splice(7, this.columns.length - 2);
      this.loadImportFileProcess();
    },
    // 获取业务员
    async getSalesVisibleMethod() {
      const data = await this.getUsersList({
        simpleRole: "salesLead,sales,salesAssist",
        limit: 99,
      });
      this.salesVisibleMember = data.userList;
    },
    // 选择了业务员后获取账龄表
    async choseSalesVisible(salesVisibleMember) {
      if (salesVisibleMember) {
        this.filterQuery.paymentSales = salesVisibleMember
          .map((x) => x.value)
          .join(",");
      } else {
        delete this.filterQuery.paymentSales;
      }
      await this.loadImportFileProcess();
    },
    async getDepartmentMethod() {
      const data = await this.getDepartmentList({
        limit: 99,
      });
      this.departmentList = data;
    },
    async choseDepartment(department) {
      if (department) {
        this.filterQuery.department = department.map((x) => x.value).join(",");
      } else {
        delete this.filterQuery.department;
      }
      await this.loadImportFileProcess();
    },

    openImportResultModal(e) {
      this.importResultModal = true;
      this.importResultData = e;
      this.importResultList = e.errorData;
    },
  },
  created() {
    let query = this.$route.query;
    this.yearMonth = dayjs().subtract(1, "month").format("YYYY-M");
    this.filterQuery.year = dayjs(this.yearMonth).year();
    this.filterQuery.month = dayjs(this.yearMonth).month() + 1;
    if (query.year) {
      this.filterQuery.year = query.year;
    }
    if (query.tableMode) {
      this.tableMode = query.tableMode;
    }
    if (query.month) {
      this.filterQuery.month = query.month;
      this.yearMonth = query.year + "-" + query.month;
    }
    this.loadImportFileProcess();
    this.getSalesVisibleMethod();
    this.getDepartmentMethod();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>
<style lang="stylus" scoped>
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

  .handle-left
    display flex
    align-items center

  .handle-right
    display flex
    align-items center

    .page-wrap
      display flex
      align-items center
      min-width 220px

.table-wrapper
  width 100%
  height calc(100% - 48px)

.import-result-modal
  height 265px
  overflow hidden
  overflow-y auto
</style>